<template>
  <div class="new-place">
    <PageHeader title="場所追加登録" :backIcon="true" />
    <div class="contents-wrapper">
      <b-loading :is-full-page="false" :active="loading" />
      <div class="detail-contents">
        <div class="detail">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="場所名"
          >
            <b-field :type="{ 'is-danger': errors[0] }" :message="errors[0]">
              <template #label>
                <span class="label-text">場所名</span>
                <b-tag type="is-danger">必須</b-tag>
              </template>
              <b-input
                class="form-item"
                v-model="place.name"
                placeholder="例）〇〇ビルA会議室、〇〇駅前喫茶店、etc..."
              ></b-input>
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <b-button class="edit-button" expanded @click="onClickSaveButton">
        <p class="text is-size-6_5 has-text-weight-bold">場所を追加登録する</p>
      </b-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { defineComponent, reactive, toRefs } from "@vue/composition-api";
import { useAuth } from "@/submodules/auth";

import { useSavePlaceMutation } from "./graphql/mutation/savePlace.generated";
import { useToast } from "@/submodules/toast";

import PageHeader from "@/components/PageHeader.vue";

const { getToken } = useAuth();
const { toastError, setSessionMessage } = useToast();

const usePlaceMutation = () => {
  const { mutate: savePlaceMutate } = useSavePlaceMutation();
  const savePlace = (name) => {
    const result = savePlaceMutate({
      accessToken: getToken(),
      name,
    });

    return result;
  };

  return savePlace;
};

export default defineComponent({
  name: "NewPlace",
  components: {
    PageHeader,
  },
  setup(_, { root }) {
    const state = reactive({
      loading: false,
      place: {
        name: "",
      },
    });

    const savePlace = usePlaceMutation();

    const onClickSaveButton = async () => {
      try {
        await savePlace(state.place.name);
        setSessionMessage("場所を新規登録しました");
        root.$router.push("/places");
      } catch (error) {
        console.error(error);
        toastError();
      }
    };

    return {
      ...toRefs(state),
      onClickSaveButton,
    };
  },
});
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 16px 16px 72px;
}
.detail-contents {
  > .detail {
    width: 100%;
    text-align: left;
    padding-top: 16px;
    .name {
      height: 20px;
      white-space: nowrap;
    }

    .value {
      height: 20px;
    }
  }
}
::v-deep .button {
  margin-top: 16px;
  color: white;
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    .text {
      padding-left: 8px;
    }
  }
}
.edit-button {
  margin-top: 32px;
  background-color: colors(green);
}
::v-deep .tag {
  height: 16px;
  margin-left: 4px;
  color: white;
  &.attendee-tag {
    color: colors(black);
  }
  span {
    font-weight: 700;
  }
}
</style>
